import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private api = "https:///mailthis.to/giovanni9972@libero.it";

  constructor(private http: HttpClient) { }
  PostMessage(input: any) {
    return this.http.post(this.api, input, { responseType: 'text' }).pipe(
      map(
        function (response: any) {
          if (response) {
            return response;
          }
        },
        (error: any) => error)
    )
  }








  // SERVICE


}
